var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.335 10.8C24.955 10.8 24.595 10.87 24.255 10.97C24.255 10.91 24.265 10.86 24.265 10.8C24.265 6.4 20.695 2.83 16.295 2.83C12.585 2.83 9.46504 5.38 8.58504 8.82C8.29504 8.76 7.99504 8.73 7.68504 8.73C4.91504 8.73 2.66504 10.98 2.66504 13.75C2.66504 16.24 4.49504 18.45 6.87504 18.84L6.91504 18.85H16.325H16.335H16.345H24.895C25.095 18.84 25.245 18.84 25.355 18.84C27.565 18.84 29.335 17.01 29.335 14.8C29.335 12.59 27.545 10.8 25.335 10.8Z",
    fill: "#9EC5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.515 26.15C10.145 26.15 9.84497 25.85 9.84497 25.48V20.56C9.84497 20.19 10.145 19.89 10.515 19.89C10.885 19.89 11.185 20.19 11.185 20.56V25.48C11.185 25.85 10.885 26.15 10.515 26.15Z",
    fill: "#66AFEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.305 24.83L8.04497 22.37C7.72497 22.18 7.61497 21.78 7.79497 21.45C7.98497 21.13 8.38497 21.02 8.71497 21.2L12.975 23.66C13.295 23.85 13.405 24.25 13.225 24.58C13.035 24.91 12.625 25.02 12.305 24.83Z",
    fill: "#66AFEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79499 24.6C7.60499 24.28 7.71499 23.87 8.04499 23.68L12.305 21.22C12.625 21.03 13.035 21.14 13.225 21.47C13.415 21.79 13.305 22.2 12.975 22.39L8.71499 24.85C8.39499 25.03 7.98499 24.92 7.79499 24.6Z",
    fill: "#66AFEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 29.17C20.255 29.17 19.955 28.87 19.955 28.5V23.57C19.955 23.2 20.255 22.9 20.625 22.9C20.995 22.9 21.295 23.2 21.295 23.57V28.49C21.295 28.87 20.995 29.17 20.625 29.17Z",
    fill: "#66AFEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.415 27.85L18.155 25.39C17.835 25.2 17.725 24.8 17.905 24.47C18.095 24.15 18.495 24.04 18.825 24.22L23.085 26.68C23.405 26.87 23.515 27.27 23.335 27.6C23.145 27.92 22.735 28.03 22.415 27.85Z",
    fill: "#66AFEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.905 27.61C17.715 27.29 17.825 26.88 18.155 26.69L22.415 24.23C22.735 24.04 23.145 24.15 23.335 24.48C23.525 24.8 23.415 25.21 23.085 25.4L18.825 27.86C18.505 28.04 18.095 27.93 17.905 27.61Z",
    fill: "#66AFEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.475565adf489072c9cf88a44d9fcba1f.svg";
export { ForwardRef as ReactComponent };